import React from 'react'
import "./computerlab.css"
import communicationimage1 from "../../Home/images/Collegephotos.png"

const computerlab = () => {
  return (
    <div className='main-containercomputerlab'>
     <img src={ communicationimage1} className='communicationimage1' />
     <div data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500">

     <div className='container-computerlab1'>
     <h1>Applied Science</h1> <hr />
     </div>
     </div>
    
     <div className='container-computerlab'>
     <div data-aos="fade-up"
     data-aos-duration="3000">
     
     <div className='container-computerlabss'>

       <div className='computerlab'>
        <p>
        It is well known that a person's worth is known by the kind of language he/she 
        speaks and how effectively he/she is able to communicate. In today's crosscultural global education and work environment, the basic college course 
        curriculum or the technical and process knowledge is not enough. So, the 
        academic domain knowledge and skills have to be complemented with global 
        communication skills to develop:
        </p>
        <ul>
          <li>Critical thinking and reasoning (eg. problem solving, analysis, logic, cause/effect)
          </li><br />
          <li>Information literacy (eg. knowledge acquisition, source discernment. 
          Management)
          </li><br />
          <li>Collaboration (e.g. synergy, team resourcing, social skills, leadership)</li> <br />
          <li>Self direction (e.g. adaptability, initiative, personal responsibility, work ethics, 
          self-advocacy) 
          </li><br /> 
          <li>Invention (e.g. creativity, innovation, integration of ideas)</li>
        </ul>
       </div> 
       <div className='communicationlab'>
        <p>
        It has been noted that majority of our students are not at home in the respective subjects have
        anuncanny tendency to steer clear of communicationas they seek confidence due to their poor
        English communication skills. Therefore, in order to inculcate functional English language
        skills right from the beginners level along with the existing curriculum. Pt. L. R. Group of
        Institutions has established a language laboratory where students get ample opportunity to
        learn about the language, enhance and experience listening and speaking skills in addition to
        other necessary life skills. Themultimedia course contentthat are providedwiththe solutionis
        oneofthebestcontentprovidersworldwide.
        </p>
        <p>The language laboratory uses a software platform for ease in operation and practice. The 
        language laboratory provides a holistic learning experience where students:</p>
        <ul>
          <li>Improve their Listening Skills
          </li>
          <li>Develop their Language Skills </li>
          <li>Move from passive learning to active learning</li>
          <li>
          Improve their Speaking Skills
          </li>
          <li>Improve their examination result</li>
        </ul>
       </div>
     </div>
     </div>
    </div>
    </div>
  )
}

export default computerlab
